

import { ComponentFactoryResolver, NgModule } from '@angular/core';
import { BaseModule, TnxSharedModule } from 'tnx-shared';
import { WorkflowFormComponent } from './workflow-form/workflow-form.component';
import { WorkflowComponent } from './workflow.component';
import { WorkflowRoutes } from './workflow.routing';

export function declaration() {
    return [WorkflowComponent, WorkflowFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration(),
    entryComponents: declaration()
})
export class WorkflowModule extends BaseModule {
    dynamicComponents = [WorkflowComponent];

    constructor(componentFactoryResolver: ComponentFactoryResolver) {
        super(componentFactoryResolver);
    }
}

@NgModule({
    imports: [WorkflowModule, WorkflowRoutes],
    exports: [WorkflowModule]
})
export class WorkflowWithRouteModule {
}
